import styled, { css } from 'styled-components';
import { RouterLink, RouterLinkProps } from '@redux-first-router-link';

interface NavItemProps {
  selected: boolean;
}

export const NavItem = styled(RouterLink)<RouterLinkProps & NavItemProps>`
  ${({ theme }) => theme.typography.xSmall}
  height: ${({ theme }) => theme.x8space * 10}px;
  line-height: ${({ theme }) => (theme.x8space - 0.2) * 10}px;
  padding: 0 ${({ theme }) => theme.x1spacePx}px;
  display: inline-block;
  position: relative;
  ${({ selected }) => {
    return (
      selected &&
      css`
        &:after {
          display: block;
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          content: '';
          height: ${({ theme }) => theme.x1spacePx / 2}px;
          background: ${({ theme }) => theme.color.brand01};
        }
      `
    );
  }};
`;
